import { Link } from "react-router-dom";
import { Card, Dropdown, Row } from "react-bootstrap";
import ReactApexCharts from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const SubLocalities = (props: any) => {
  let data: any = props.data;
  let quantities: [] = data.map((item: any) => item.followersCount);
  let names: [] = data.map((item: any) => item.subLocalityName);
  const apexOpts: ApexOptions = {
    chart: {
      height: 332,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    colors: ["#16a7e9"],
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        name: "Followers",
        data:quantities, 
      },
    ],
    xaxis: {
      categories: names, // Dynamically map the admin names
      axisBorder: {
        show: false,
      },
      // With ~60 sub-localities the labels overlap into an unreadable
      // smear. Thin the ticks, rotate, and cap label length — the full
      // name is always in the tooltip and the table below.
      tickAmount: Math.min(names.length, 15),
      labels: {
        rotate: -45,
        hideOverlappingLabels: true,
        trim: true,
        maxHeight: 90,
        style: {
          fontSize: "10px",
        },
        formatter: function (val: any) {
          return typeof val === "string" && val.length > 14
            ? val.slice(0, 13) + "…"
            : val;
        },
      },
    },
    grid: {
      strokeDashArray: 5,
    },
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h4 className="header-title">Sub Locality Followers</h4>
        {/* <Dropdown>
          <Dropdown.Toggle as="a" className="arrow-none card-drop">
            <i className="ri-more-2-fill" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item>Refresh Report</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
      </Card.Header>

      <Card.Body className="pt-0">
        <Row>
          <ReactApexCharts
            className="apex-charts"
            options={apexOpts}
            height={350}
            series={apexOpts.series}
            type="bar"
          />
          <div className="table-responsive mt-3">
            <table className="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Sub Locality</th>
                  <th>Followers</th>
                </tr>
              </thead>
              <tbody>
              {/* Dynamically render table rows from the data */}
              {data.map((item:any, index:number) => (
                <tr key={index}>
                  <td>
                    <Link to="#" className="text-muted">
                      {item.subLocalityName}
                    </Link>
                  </td>
                  <td>{item.followersCount}</td>
                </tr>
              ))}
            </tbody>
            </table>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SubLocalities;
